<template>
  <header class="content-hd">
    <div class="avatars-div animate__animated animate__flip">
      <img src="../../assets/wut_1c_B.jpg" class="avatars" />
    </div>
    <div style="flex: 1;width: 100%">
      <section class="title">
        <div class="name animate__animated animate__fadeInDown">
          <h1>武童</h1>
        </div>
        <div class="job animate__animated animate__fadeInDown">
          <h2>Java开发工程师 | 全栈工程师 | 软件架构师</h2>
        </div>
      </section>
      <section class="info animate__animated animate__fadeInLeft">
        <ul class="info-basic">
          <li>
            <svg class="info-icon" viewBox="0 0 1024 1024" width="14" height="14"><path d="M512 64C390 64 291.2 162.8 291.2 284.8c0 90.4 53.6 168 130.4 202.4-127.2 38.4-220 156-220 295.2 0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16 0-140.8 110.4-255.2 246.4-255.2S758.4 741.6 758.4 882.4c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16 0-139.2-92.8-256.8-220-295.2 76.8-34.4 130.4-112 130.4-202.4C732.8 162.8 634 64 512 64zm0 353.6c-73.2 0-132.8-59.6-132.8-132.8S438.8 152 512 152s132.8 59.6 132.8 132.8S585.2 417.6 512 417.6z"/></svg>
            男 / 1997.12
          </li>
          <li>
            <svg class="info-icon" viewBox="0 0 1024 1024" width="14" height="14"><path d="M832 320v-32c0-176-144-320-320-320S192 112 192 288v32C96 344 32 432 32 544c0 120 80 216 192 240 8 1.6 16-4.8 16-13.6v-32c0-7.2-4.8-13.6-12-15.2-80-19.2-140-92.8-140-179.2 0-86.4 60-160 140-179.2 7.2-1.6 12-8 12-15.2v-61.6c0-140.8 115.2-256 256-256s256 115.2 256 256v61.6c0 7.2 4.8 13.6 12 15.2 80 19.2 140 92.8 140 179.2 0 86.4-60 160-140 179.2-7.2 1.6-12 8-12 15.2v32c0 8.8 8 15.2 16 13.6 112-24 192-120 192-240 0-112-64-200-160-224z"/></svg>
            大连科技学院 · 软件工程 · 本科（2016-2020）
          </li>
          <li><span class="info-label">擅长：</span>后端开发、架构设计、业务梳理、系统集成、<strong class="info-emph">AI大模型应用与开发</strong></li>
          <li class="info-cert"><span class="info-label">证书：</span>系统架构设计师、系统分析师、软件设计师、信创系统架构师、高等学校教师资格</li>
          <li>
            <svg class="info-icon" viewBox="0 0 1024 1024" width="14" height="14"><path d="M832 320 832 256c0-176-144-320-320-320-123.2 0-230.4 70.4-283.2 172.8-9.6 17.6-3.2 39.2 14.4 48.8 17.6 9.6 39.2 3.2 48.8-14.4C232 73.6 313.6 24 512 24c149.6 0 272 122.4 272 272v24H192c-44 0-80 36-80 80v464c0 44 36 80 80 80h640c44 0 80-36 80-80V400c0-44-36-80-80-80zM560 688v97.6c0 17.6-14.4 32-32 32s-32-14.4-32-32V688c-38.4-13.6-64-49.6-64-91.2 0-53.6 43.2-96.8 96.8-96.8s96.8 43.2 96.8 96.8c-0.8 41.6-26.4 77.6-65.6 91.2z"/></svg>
            在线简历：<a href="https://wut.wlmq8.com" target="_blank" class="info-link">wut.wlmq8.com</a>
          </li>
        </ul>
      </section>
      <section class="contact animate__animated animate__fadeInRight">
        <ul>
          <li>
            <a href="/" target="_blank">
              <span class="contact-link">新疆乌鲁木齐（外地也OK）</span>
              <span class="iconfont">
                <svg width="16px" height="16px" viewBox="0 0 1024 1024">
                  <path
                    d="M512 42.581333l-469.333333 469.333333 31.146667 31.146667L170.666667 446.250667l0 438.186667 682.666667 0L853.333333 446.208l96.853333 96.896 31.146667-31.146667L512 42.581333zM426.666667 841.770667l0-298.666667 170.666667 0 0 298.666667L426.666667 841.770667zM810.666667 841.770667l-170.666667 0 0-341.333333L384 500.437333l0 341.333333L213.333333 841.770667 213.333333 403.584l298.666667-298.666667 298.666667 298.666667L810.666667 841.770667z"
                  />
                </svg>
              </span>
            </a>
          </li>
          <li>
            <a href="https://gitee.com/wu_xiao_di" target="_blank">
              <span class="contact-link">Gitee - 武小弟</span>
              <span class="iconfont">
                <svg width="16px" height="16px" viewBox="0 0 1024 1024">
                  <path
                    d="M941.714 512q0 143.433-83.712 258.011t-216.283 158.574q-15.433 2.853-22.565-3.986t-7.131-17.152v-120.576q0-55.442-29.696-81.152 32.585-3.438 58.587-10.277t53.723-22.272 46.299-37.998 30.281-60.014 11.703-86.016q0-69.157-45.129-117.723 21.138-52.005-4.571-116.553-16.018-5.157-46.299 6.29t-52.553 25.161l-21.723 13.714q-53.138-14.848-109.714-14.848t-109.714 14.848q-9.143-6.29-24.283-15.433t-47.726-22.016-49.152-7.717q-25.161 64.585-3.986 116.553-45.129 48.567-45.129 117.723 0 48.567 11.703 85.723t29.989 60.014 46.007 38.29 53.723 22.272 58.587 10.277q-22.857 20.553-28.014 58.843-11.995 5.705-25.71 8.558t-32.585 2.853-37.413-12.288-31.707-35.73q-10.862-18.286-27.721-29.696t-28.27-13.714l-11.447-1.719q-11.995 0-16.567 2.56t-2.853 6.583 5.157 8.009 7.424 6.839l3.986 2.853q12.581 5.705 24.869 21.723t17.993 29.147l5.705 13.129q7.424 21.723 25.161 35.145t38.29 17.152 39.717 3.986 31.707-2.011l13.129-2.304q0 21.723 0.293 50.871t0.293 30.866q0 10.277-7.424 17.152t-22.857 3.986q-132.571-43.995-216.283-158.574t-83.712-258.011q0-119.442 58.843-220.27t159.707-159.707 220.27-58.843 220.27 58.843 159.707 159.707 58.843 220.27z"
                  />
                </svg>
              </span>
            </a>
          </li>
          <li>
            <a href="mailto:1364342822@qq.com" target="_blank">
              <span class="contact-link">1364342822@qq.com</span>
              <span class="iconfont">
                <svg width="16px" height="16px" viewBox="0 0 1024 1024">
                  <path
                    d="M903.808 239.04l-818.304 0 0 545.92 852.992 0 0-545.92-34.688 0zM869.664 273.152l-329.536 329.536c-15.04 15.04-41.248 15.04-56.288 0l-329.6-329.536 715.392 0zM119.616 286.752l221.536 221.504-221.536 221.536 0-443.072zM146.848 750.848l218.464-218.432 94.432 94.4c13.952 13.952 32.512 21.664 52.256 21.664s38.304-7.712 52.256-21.664l94.432-94.432 218.432 218.432-730.304 0zM904.384 729.824l-221.536-221.568 221.536-221.568 0 443.136z"
                  />
                </svg>
              </span>
            </a>
          </li>
          <li>
            <a href="tel:18119151533" target="_blank">
              <span class="contact-link">18119151533</span>
              <span class="iconfont">
                <svg width="16px" height="16px" viewBox="0 0 1024 1024">
                  <path
                    d="M256 1024l512 0c26.464 0 48-21.536 48-48l0-928c0-26.464-21.536-48-48-48l-512 0c-26.464 0-48 21.536-48 48l0 928c0 26.464 21.536 48 48 48zM240 48c0-8.832 7.168-16 16-16l512 0c8.832 0 16 7.168 16 16l0 928c0 8.832-7.168 16-16 16l-512 0c-8.832 0-16-7.168-16-16l0-928zM288 864l448 0c8.832 0 16-7.168 16-16l0-672c0-8.832-7.168-16-16-16l-448 0c-8.832 0-16 7.168-16 16l0 672c0 8.832 7.168 16 16 16zM304 192l416 0 0 640-416 0 0-640zM496 928c0 17.664 14.336 32 32 32s32-14.336 32-32c0-17.664-14.336-32-32-32-17.664 0-32 14.336-32 32zM448 128l128 0c8.832 0 16-7.168 16-16s-7.168-16-16-16l-128 0c-8.832 0-16 7.168-16 16s7.168 16 16 16z"
                  />
                </svg>
              </span>
            </a>
          </li>
        </ul>
      </section>
    </div>
  </header>
</template>

<script>
export default {
  name: "BaseInfo",
  data() {
    return {};
  },
  mounted() {},
  computed: {}
};
</script>



// WEBPACK FOOTER //
// src/components/common/baseInfo.vue